import { render, staticRenderFns } from "./SubAttachment.vue?vue&type=template&id=9c2e770a&scoped=true&lang=pug&"
import script from "./SubAttachment.vue?vue&type=script&lang=js&"
export * from "./SubAttachment.vue?vue&type=script&lang=js&"
import style0 from "./SubAttachment.vue?vue&type=style&index=0&id=9c2e770a&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c2e770a",
  null
  
)

export default component.exports